{
  "ts": 1751988279,
  "tsCommit": 1751896075,
  "repoName": "NCApp3",
  "branchName": "prod",
  "rev": "05bcb9f",
  "ver": "20250708_1524_NCApp3_prod_05bcb9f",
  "env": "production",
  "appVer": "5.5.3",
  "isBranchDeployment": false,
  "e2eApiHostUrl": "https://api-master.naturalcycles.com"
}
